import _ from 'lodash';
import React, { Component } from 'react';

import qs from 'qs';
import moment from 'moment';
import ReactTooltip from 'react-tooltip';

import { createBrowserHistory } from 'history';

import {
  authorizeIntegration,
  deactivateIntegration,
} from '../../../actions/integrations';

import {
  reloadSalesforceData,
  refreshDealConfidenceCalculations,
} from '../../../actions/integrations/salesforce';

import CustomDealStageMappingEditor from './customDealStageMappingEditor';

import {
  appConfig,
  getIcon,
} from '../../../util';

import {
  getImperativesStages
} from '../../../util/data';

import {
  Switch
} from '../../shared';

class IntegrationsSection extends Component{

  state = {
    handlingOAuthCallback: false,
    disablingIntegration: false,
    reloadingSalesforceData: false,
  }

  activateIntegration(){
    const integrationType = this.props.match.params.integrationCallback;
    const params = qs.parse(window.location.search, { ignoreQueryPrefix: true });

    if(!params || !params.code){
      return;
    }

    console.log('activating with code: ', params.code);

    authorizeIntegration(integrationType, params.code, err => {

      const history = createBrowserHistory({ basename: `` });
      history.replace('/settings/integrations');

      if(err){
        this.setState({
          pageMessage: {
            messageContent: 'Error during setup. Please contact support if this issue persists.',
            messageType: 'error'
          },
          handlingOAuthCallback: false,
        });
      }
      else{
        this.setState({
          pageMessage: {
            messageContent: 'Integration setup successfully!',
            messageType: 'success'
          },
          handlingOAuthCallback: false,
        });
      }
    });
  }

  handleIntegrationCallbackOnMountOrUpdate(){
    const integrationCallback = this.props.match.params.integrationCallback;

    if(integrationCallback && !this.state.handlingOAuthCallback){
      this.setState({
        handlingOAuthCallback: integrationCallback
      });

      this.activateIntegration();
    }
    else if(!integrationCallback && this.state.handlingOAuthCallback){
      this.setState({
        handlingOAuthCallback: false
      });
    }
  }

  componentDidMount(){
    this.handleIntegrationCallbackOnMountOrUpdate();
  }

  componentDidUpdate(){
    this.handleIntegrationCallbackOnMountOrUpdate();
  }

  salesforceIntegrationAuthorizationLink(){
    return `https://login.salesforce.com/services/oauth2/authorize?response_type=code&client_id=${this.props.organization.integrations.salesforce.clientId}&redirect_uri=${appConfig().APP_URL}/settings/integrations/salesforce`;
  }

  disableSFIntegration(){
    this.setState({ disablingIntegration: true });

    deactivateIntegration('salesforce', err => {
      this.setState({ disablingIntegration: false });
      if(err){
        this.setState({
          pageMessage: {
            messageContent: 'Error disabling integration. Please contact support if this issue persists.',
            messageType: 'error'
          }
        });
      }
      else{
        this.setState({
          pageMessage: {
            messageContent: 'Integration disabled!',
            messageType: 'success'
          },
        });
      }
    });
  }

  enableCustomDealStageMapping(){

    //if mapping already configured, just turn on
    if(this.props.organization.customDealStageMapping){
      this.props.updateOrganizationProps({
        customDealStageMappingEnabled: true,
      });
    }
    else{
      this.props.updateOrganizationProps({
        customDealStageMapping: {},
        customDealStageMappingEnabled: true,
      });
    }
  }
  disableCustomDealStageMapping(){
    this.props.updateOrganizationProps({
      customDealStageMappingEnabled: false,
    });
  }

  toggleCustomDealStageMapping(toggleOn){
    if(toggleOn){
      this.enableCustomDealStageMapping();
    }
    else{
      this.disableCustomDealStageMapping();
    }
  }

  toggleOrganizationProp(propName, toggleOn){
    this.props.updateOrganizationProps({
      [propName]: toggleOn,
    });
  }

  updateDealStageMapping(newMapping){
    this.props.updateOrganizationProps({
      customDealStageMapping: newMapping,
    }, true);
  }

  handleReloadSalesforceData(){
    if(this.state.reloadingSalesforceData){
      return;
    }

    this.setState({ reloadingSalesforceData: true });

    reloadSalesforceData(() => {
      this.setState({ reloadingSalesforceData: false });
    });
  }

  handleRefreshDealConfidenceCalculations(){
    if(this.state.refreshingDealConfidenceCalculations){
      return;
    }

    this.setState({ refreshingDealConfidenceCalculations: true });

    refreshDealConfidenceCalculations(() => {
      this.setState({ refreshingDealConfidenceCalculations: false });
    });
  }

  render(){

    const {
      handlingOAuthCallback,
      reloadingSalesforceData,
      refreshingDealConfidenceCalculations,
     } = this.state;

    const integrations = {
      salesforce: ((this.props.organization || {}).integrations || {}).salesforce
    }

    const integrationDealNameEditingEnabled = !!(this.props.organization || {}).integrationDealNameEditingEnabled;
    const integrationAccountEditingEnabled = !!(this.props.organization || {}).integrationAccountEditingEnabled;
    const integrationNextStepEditingEnabled = !!(this.props.organization || {}).integrationNextStepEditingEnabled;
    const integrationStageUpdatingEnabled = !!(this.props.organization || {}).integrationStageUpdatingEnabled;
    const integrationDealCreationEnabled = !!(this.props.organization || {}).integrationDealCreationEnabled;
    const customDealStageMappingEnabled = !!(this.props.organization || {}).customDealStageMappingEnabled;
    const customOwnerLookupId = ((this.props.organization.integrations || {}).salesforce ||{}).customOwnerLookupId;

    return(
      <div className="page-section">
        <div className="integrations-list">
          {integrations.salesforce &&
            <div className="integration">
              {getIcon('salesforce', 'integration-icon')}
              <div className="details">
                <h3>Salesforce</h3>
                <p className={integrations.salesforce.status === 'live' ? 'active' : 'inactive'}>{integrations.salesforce.status === 'live' ? 'Live' : ((handlingOAuthCallback ? 'Finalizing' : 'Awaiting') + ' Setup')}</p>
                {integrations.salesforce.lastSynced &&
                  <p className="last-synced">Last synced: {moment(integrations.salesforce.lastSynced.toDate()).fromNow()}</p>
                }
              </div>
              <div className="actions">
                {integrations.salesforce.status === 'ready' &&
                  <a href={this.salesforceIntegrationAuthorizationLink()}><button disabled={handlingOAuthCallback} className="button blue-button">{handlingOAuthCallback === 'salesforce' ? 'Finalizing...' : 'Setup now'}</button></a>
                }
                {integrations.salesforce.status === 'live' &&
                  <button disabled={this.state.reloadingSalesforceData} onClick={this.handleReloadSalesforceData.bind(this)} className="button blue-button button-tiny">{reloadingSalesforceData ? 'Reloading...' : 'Reload All Data'}</button>
                }
                {integrations.salesforce.status === 'live' &&
                  <button disabled={this.state.refreshingDealConfidenceCalculations} onClick={this.handleRefreshDealConfidenceCalculations.bind(this)} className="button blue-button button-tiny">{refreshingDealConfidenceCalculations ? 'Refreshing...' : 'Refresh Confidence Calculations'}</button>
                }
                {integrations.salesforce.status === 'live' &&
                  <button disabled={this.state.disablingIntegration} onClick={this.disableSFIntegration.bind(this)} className="button danger-button-outline button-tiny">Revoke</button>
                }
              </div>
              {integrations.salesforce.status === 'live' &&
                <div className="integration-options">
                  <h3>Salesforce Integration Options</h3>
                  <div className="integration-option">
                    <label>Employees can update deal name from Velocity</label>
                      <Switch
                        id="some-switch"
                        checked={integrationDealNameEditingEnabled}
                        onChange={checked => { this.toggleOrganizationProp('integrationDealNameEditingEnabled', checked); } }
                      />
                  </div>
                  <div className="integration-option">
                    <label>Employees can update deal accounts from Velocity</label>
                      <Switch
                        id="some-switch"
                        checked={integrationAccountEditingEnabled}
                        onChange={checked => { this.toggleOrganizationProp('integrationAccountEditingEnabled', checked); } }
                      />
                  </div>
                  <div className="integration-option">
                    <label>Employees can update deal "Next Step" from Velocity</label>
                      <Switch
                        id="some-switch"
                        checked={integrationNextStepEditingEnabled}
                        onChange={checked => { this.toggleOrganizationProp('integrationNextStepEditingEnabled', checked); } }
                      />
                  </div>
                  <div className="integration-option">
                    <label>Employees can update deal Deal Stage from Velocity</label>
                      <Switch
                        id="some-switch"
                        checked={integrationStageUpdatingEnabled}
                        onChange={checked => { this.toggleOrganizationProp('integrationStageUpdatingEnabled', checked); } }
                      />
                  </div>
                  <div className="integration-option">
                    <label>Allow deal/opportunity creation from Velocity</label>
                      <Switch
                        id="some-switch"
                        checked={integrationDealCreationEnabled}
                        onChange={checked => { this.toggleOrganizationProp('integrationDealCreationEnabled', checked); } }
                        disabled={!!customOwnerLookupId}
                      />
                  </div>
                  <div
                    className="integration-option"
                    data-tip="For now this is required for this integration"
                    data-for="sf-integration-deal-stages-toggle-tooltip"
                  >
                    <label>Use Salesforce Deal Stages</label>
                      <Switch
                        id="some-switch"
                        checked={true}
                        disabled={true}
                        onChange={checked => { /* do nothing as this is disabled */ } }
                      />
                    <ReactTooltip id="sf-integration-deal-stages-toggle-tooltip" effect="solid" place="top" />
                  </div>
                  <div className="integration-option">
                    <label>Map Objectives & Reciprocations to SF Deal Stages</label>
                      <Switch
                        id="some-switch"
                        checked={customDealStageMappingEnabled}
                        onChange={checked => { this.toggleCustomDealStageMapping(checked); } }
                      />
                    {customDealStageMappingEnabled &&
                      <CustomDealStageMappingEditor
                        organization={this.props.organization}
                        updateDealStageMapping={this.updateDealStageMapping.bind(this)}
                      />
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    )
  }
}

export default IntegrationsSection;



// WEBPACK FOOTER //
// ./src/components/settings/sections/integrationsSection.js